<template>
  <div style="min-height:40px;min-width:240px">
    <div class="ui right floated pagination menu">
      <a v-bind:class="(disabledFirstPage ? 'disabled ' : '') + 'icon item'" v-on:click="backToOne()">
        <i class="angle double left icon"></i>
      </a>
      <a v-bind:class="(disabledPreviousPage ? 'disabled ' : '') + 'icon item'" v-on:click="backToPrevious()">
        <i class="left chevron icon"></i>
      </a>
      <span class="item">{{currentPage+1}} / {{maxPage+1}}</span>
      <a v-bind:class="(disabledNextPage ? 'disabled ' : '') + 'icon item'" v-on:click="forwardToNext()">
        <i class="right chevron icon"></i>
      </a>
      <a v-bind:class="(disabledLastPage ? 'disabled ' : '') + 'icon item'" v-on:click="forwardToLast()">
        <i class="angle double right icon"></i>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: ['currentPage', 'currentPageRequested', 'maxPage'],
  methods: {
    backToOne: function () {
      if (!this.disabledFirstPage) this.$emit('back-to-1')
    },
    backToPrevious: function () {
      if (!this.disabledPreviousPage) this.$emit('back')
    },
    forwardToNext: function () {
      if (!this.disabledNextPage) this.$emit('forward')
    },
    forwardToLast: function () {
      if (!this.disabledLastPage) this.$emit('forward-all-the-way')
    },
  },
  computed: {
    disabledFirstPage: function () {
      return this.currentPage === 0 || this.currentPage !== this.currentPageRequested
    },
    disabledPreviousPage: function () {
      return this.currentPage === 0 || this.currentPage !== this.currentPageRequested
    },
    disabledNextPage: function () {
      return this.currentPage === this.maxPage || this.currentPage !== this.currentPageRequested
    },
    disabledLastPage: function () {
      return this.currentPage === this.maxPage || this.currentPage !== this.currentPageRequested
    },
  }
}
</script>



// WEBPACK FOOTER //
// ProductSettingsPage.Pagination.vue?9b88a95c